import { EntityKind } from 'mdello-client-ts/dist/src/interfaces/admin/entity.interface';
import { Paginated } from 'mdello-client-ts/dist/src/interfaces/common/paging.interface';
import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { getClient } from 'src/util/mdello-instance';
import { VacationsRequest, VacationsRequestData } from '../interfaces/requestsResponse.interface';

const fetchVacations = async (category: string): Promise<VacationsRequest | undefined> => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  const data = await getClient()?.listEntities({
    kind: EntityKind.REQUEST_ACTION,
    projectId: currentProject._id
  });

  if (!data) return;

  const filteredData: VacationsRequestData[] = data?.data.filter(
    (request: VacationsRequestData) => {
      return request.category === category;
    }
  );

  filteredData.sort((a, b) => {
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });

  const paging: Paginated = { ...data.paging, total: filteredData.length };

  return { data: filteredData, paging };
};

export const useGetVacations = (category: string) => {
  const { notify } = useNotification();

  return useQuery([QueryKey.REQUESTS], () => fetchVacations(category), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
